var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.0312,
    y: 18.0986,
    width: 10.6138,
    height: 42.4554,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9411 61.3145C64.3415 61.8709 64.3674 62.6136 64.0068 63.1965C63.6462 63.7794 62.9701 64.0879 62.2935 63.9781H2.70704C2.03046 64.0879 1.35434 63.7794 0.993763 63.1965C0.633187 62.6136 0.659118 61.8709 1.05947 61.3145L31.1685 1.09937C31.9014 -0.366457 33.0991 -0.366457 33.8321 1.09937L63.9411 61.3145ZM32.501 18.7313C34.0436 18.7313 35.2942 19.9819 35.2942 21.5245V42.3797C35.2942 43.9223 34.0436 45.1729 32.501 45.1729C30.9584 45.1729 29.7079 43.9223 29.7079 42.3797V21.5245C29.7079 19.9819 30.9584 18.7313 32.501 18.7313ZM32.4184 50.0148C32.4399 50.0144 32.4613 50.0142 32.4827 50.0143L32.5527 50.0148C34.4347 50.0502 35.9624 51.5474 36.0359 53.4283L36.0361 53.4346C36.0709 54.3796 35.7247 55.299 35.0751 55.9862C34.4256 56.6735 33.5272 57.0711 32.5818 57.0896L32.5269 57.0902L32.5032 57.0902C30.5996 57.0842 29.0389 55.5788 28.9643 53.6766L28.964 53.6698C28.9292 52.7249 29.2755 51.8055 29.925 51.1182C30.5746 50.431 31.4729 50.0334 32.4184 50.0148Z",
    fill: "#FFAD00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0e332d751dd14270981fcf4773d784ac.svg";
export { ForwardRef as ReactComponent };